export function downloadHomeContract(id) {
    return axios({
        url: `/api/test/insurance/home/contract/take`,
        method: 'post',
        data: {
            contractId: id,
        },
    });
}
